import React from "react";
import styles from "./input.module.css";

const InputCustom = ({ type, label, placeholder, name, formikHandler , formikErrors , formikErrorsName }) => {
  return (
    <div className={styles.inputWrap}>
      
      <label className={styles.label}>{label}      {name === 'salary' ? <span>(به دلار)</span> : null}</label>
      <input
        name={name}
        type={type}
        className={formikErrors ? styles.inputError : styles.input}
        placeholder={placeholder}
        {...formikHandler}
      />
      {formikErrors && <p className={styles.errorText}>{formikErrorsName}</p>}
    </div>
  );
};

export default InputCustom;
